export const moduleName = 'communityInfo'
